// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/TrendChart/TrendChart.scss
// module id = 4701
// module chunks = 50